module.exports = __webpack_public_path__ + "img/17_63.1050ab6b.png";